import { prepCommonPageProvider } from "pages/commonPage";
import { Id } from "core/utils";
import { showNav, hideFooter } from "pages/commonPage/Nav";
export var prepRoute = function () { return ({
    match: function (type) {
        return type === "BasicPage";
    },
    page: prepCommonPageProvider(Id.component.basic),
    showNav: showNav,
    hideFooter: hideFooter,
}); };
